"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractService2 = _interopRequireDefault(require("../../AbstractService"));

var _ServiceException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/ServiceException"));

var _ServiceUrlUtility = _interopRequireDefault(require("../../util/ServiceUrlUtility"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * This class handles CRUD operations for MvEcom shopping bag API.
 */
var MvEcomService = /*#__PURE__*/function (_AbstractService) {
  _inherits(MvEcomService, _AbstractService);

  var _super = _createSuper(MvEcomService);

  function MvEcomService() {
    var _this;

    _classCallCheck(this, MvEcomService);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "serviceVersion", '2.0');

    return _this;
  }

  _createClass(MvEcomService, [{
    key: "addToCart",

    /**
     * Returns cart count.
     *
     * @param {object} config Configuration.
     * @param {object} config.localizedInformation Oversatta data.
     * @param {object[]} config.items Array of retail item objects.
     * @param {string} config.bagType IRW bag type. Valid values: "onlineshoppingcart", "onlineshoppinglist".
     * @param {string} config.bagName IRW bag name.
     * @param {string} config.userId IRW userid.
     * @returns {Promise} Promise object.
     */
    value: function addToCart(config) {
      return this._addTo(config);
    }
    /**
     * Returns cart count.
     *
     * @param {object} config Configuration.
     * @param {object} config.localizedInformation Oversatta data.
     * @param {string} config.bagType IRW bag type. Valid values: "onlineshoppingcart", "onlineshoppinglist".
     * @param {string} config.bagName IRW bag name.
     * @param {string} config.userId IRW userid.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "getCartCount",
    value: function getCartCount(config) {
      var _this2 = this;

      return this._getCartInformation(config).then(function (cartInformation) {
        if (cartInformation === null) {
          return 0;
        }

        return _this2._getCount(config, cartInformation);
      });
    }
    /**
     * Returns cart count.
     *
     * @param {object} config Configuration.
     * @param {object} config.localizedInformation Oversatta data.
     * @param {object[]} config.items Array of retail item objects.
     * @param {string} config.bagType IRW bag type. Valid values: "onlineshoppingcart", "onlineshoppinglist".
     * @param {string} config.bagName IRW bag name.
     * @param {string} config.userId IRW userid.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "addToList",
    value: function addToList(config) {
      return this._addTo(config);
    }
    /**
     * Returns cart count.
     *
     * @param {object} config Configuration.
     * @param {object} config.localizedInformation Oversatta data.
     * @param {string} config.bagType IRW bag type. Valid values: "onlineshoppingcart", "onlineshoppinglist".
     * @param {string} config.bagName IRW bag name.
     * @param {string} config.userId IRW userid.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "getListCount",
    value: function getListCount(config) {
      var _this3 = this;

      return this._getCartInformation(config).then(function (cartInformation) {
        if (cartInformation === null) {
          return 0;
        }

        return _this3._getCount(config, cartInformation);
      });
    }
    /**
     * Adds to cart or list.
     *
     * @param {object} config Configuration.
     * @param {object} config.localizedInformation Oversatta data.
     * @param {string} config.bagType IRW bag type. Valid values: "onlineshoppingcart", "onlineshoppinglist".
     * @param {string} config.bagName IRW bag name.
     * @param {string} config.userId IRW userid.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_addTo",
    value: function _addTo(config) {
      var _this4 = this;

      return this._getCartInformation(config).then(function (cartInformation) {
        if (cartInformation === null) {
          return _this4._create(config);
        }

        return _this4._update(Object.assign({}, config, {
          cartId: cartInformation.id
        })).then(function (updateInformation) {
          if (updateInformation.CartCount === null) {
            return _this4._getCount(config).then(function (cartCount) {
              updateInformation.CartCount = cartCount;
              return updateInformation;
            });
          }

          return updateInformation;
        });
      });
    }
    /**
     * Creates cart or list.
     *
     * @param {object} config Configuration.
     * @param {object} config.localizedInformation Oversatta data.
     * @param {string} config.bagType IRW bag type. Valid values: "onlineshoppingcart", "onlineshoppinglist".
     * @param {string} config.bagName IRW bag name.
     * @param {string} config.userId IRW userid.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_create",
    value: function _create(config) {
      var _this5 = this;

      return new Promise(function (resolve) {
        fetch(_this5._getEndpointUrl(config), {
          method: 'POST',
          headers: _this5._getHeaders(config),
          credentials: 'include',
          body: _this5._getCreateBody(config)
        }).then(_this5._handleJsonResponse.bind(_this5)).then(function (response) {
          resolve(_this5._parseResponse(response));
        });
      });
    }
    /**
     * Updates cart or list.
     *
     * @param {object} config Configuration.
     * @param {object} config.localizedInformation Oversatta data.
     * @param {string} config.bagType IRW bag type. Valid values: "onlineshoppingcart", "onlineshoppinglist".
     * @param {string} config.bagName IRW bag name.
     * @param {string} config.userId IRW userid.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_update",
    value: function _update(config) {
      var _this6 = this;

      return new Promise(function (resolve) {
        var url = _this6._getEndpointUrl(config) + '/' + config.cartId + '/items';
        fetch(url, {
          method: 'PUT',
          headers: _this6._getHeaders(config),
          credentials: 'include',
          body: _this6._getUpdateBody(config)
        }).then(_this6._handleJsonResponse.bind(_this6)).then(function (response) {
          resolve(_this6._parseResponse(response));
        });
      });
    }
    /**
     * Gets request body for create.
     *
     * @param {object} config Configuration.
     * @param {object} config.localizedInformation Oversatta data.
     * @param {string} config.bagType IRW bag type. Valid values: "onlineshoppingcart", "onlineshoppinglist".
     * @param {string} config.bagName IRW bag name.
     * @param {string} config.userId IRW userid.
     * @returns {string} Request body for create.
     */

  }, {
    key: "_getCreateBody",
    value: function _getCreateBody(config) {
      var json = {
        bagType: config.bagType.toUpperCase(),
        bagSource: 'IRW',
        bagName: config.bagName || config.bagType,
        customerSource: 'IRW',
        customerId: config.userId,
        shoppingBagSectionList: [{
          shoppingBagItemList: []
        }]
      };
      var list = json.shoppingBagSectionList[0].shoppingBagItemList;

      var _iterator = _createForOfIteratorHelper(config.items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (typeof item.id !== 'string' || typeof item.type !== 'string' || typeof item.qty !== 'number') {
            throw new _ServiceException.default('Item was not in a valid format. Please use this format: { id: 123456, type: "ART", qty: 1 }');
          }

          list.push({
            itemType: item.type.toUpperCase(),
            itemNo: item.id,
            itemQty: item.qty
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return JSON.stringify(json);
    }
    /**
     * Gets request body for update.
     *
     * @param {object} config Configuration.
     * @param {object} config.localizedInformation Oversatta data.
     * @param {string} config.bagType IRW bag type. Valid values: "onlineshoppingcart", "onlineshoppinglist".
     * @param {string} config.bagName IRW bag name.
     * @param {string} config.userId IRW userid.
     * @returns {string} Request body for update.
     */

  }, {
    key: "_getUpdateBody",
    value: function _getUpdateBody(config) {
      var list = [];

      var _iterator2 = _createForOfIteratorHelper(config.items),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;

          if (typeof item.id !== 'string' || typeof item.type !== 'string' || typeof item.qty !== 'number') {
            throw new _ServiceException.default('Item was not in a valid format. Please use this format: { id: 123456, type: "ART", qty: 1 }');
          }

          list.push({
            ItemType: item.type,
            ItemNo: item.id,
            ItemQty: item.qty
          });
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return JSON.stringify(list);
    }
    /**
     * Parse response.
     *
     * @param {Response} response Response to parse.
     * @returns {object} Parsed response.
     */

  }, {
    key: "_parseResponse",
    value: function _parseResponse(response) {
      var _response$;

      var CartCount = this._calculateCartCountFromResponse(response);

      var parsed = {
        CartCount: CartCount,
        ErrorList: []
      };

      if (_typeof(response) === 'object' && response !== null && ((_response$ = response[0]) === null || _response$ === void 0 ? void 0 : _response$.errorCode)) {
        var errorObject = response;
        var errorAttributeList = Array.isArray(errorObject) ? errorObject : [errorObject];

        var _iterator3 = _createForOfIteratorHelper(errorAttributeList),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var error = _step3.value;
            var errorMessage = error.errorMessage || {};
            var errorCode = error.errorCode || {};
            var message = errorMessage ? errorMessage : null;
            var code = errorCode ? errorCode : null;
            var items = [];

            if (error.errorAttributeList && Array.isArray(error.errorAttributeList)) {
              var _iterator4 = _createForOfIteratorHelper(error.errorAttributeList),
                  _step4;

              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  var attribute = _step4.value;

                  if (attribute.value && attribute.value) {
                    items.push(String(attribute.value));
                  }
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
            }

            parsed.ErrorList.push({
              code: String(code),
              message: message,
              items: items
            });
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }

      return parsed;
    }
    /**
     * Gets count of items in cart or list.
     *
     * @param {object} config Configuration.
     * @param {object} config.localizedInformation Oversatta data.
     * @param {string} config.bagType IRW bag type. Valid values: "onlineshoppingcart", "onlineshoppinglist".
     * @param {string} config.bagName IRW bag name.
     * @param {string} config.userId IRW userid.
     * @param {object} cartInformation Cart information.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_getCount",
    value: function _getCount(config, cartInformation) {
      var _this7 = this;

      return new Promise(function (resolve) {
        _this7._getCart(config, cartInformation).then(function (cart) {
          resolve(cart.cartCount);
        });
      });
    }
    /**
     * Gets information about cart or list.
     *
     * @param {object} config Configuration.
     * @param {object} config.localizedInformation Oversatta data.
     * @param {string} config.bagType IRW bag type. Valid values: "onlineshoppingcart", "onlineshoppinglist".
     * @param {string} config.bagName IRW bag name.
     * @param {string} config.userId IRW userid.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_getCartInformation",
    value: function _getCartInformation(config) {
      var _this8 = this;

      return new Promise(function (resolve) {
        fetch(_this8._getEndpointUrl(config), {
          headers: _this8._getHeaders(config),
          credentials: 'include'
        }).then(_this8._handleJsonResponse.bind(_this8)).then(function (response) {
          if (!response || Object.keys(response).length === 0) {
            resolve(null);
          } else {
            resolve({
              id: response[0].bagId,
              name: config.bagName,
              type: response[0].bagType
            });
          }
        });
      });
    }
    /**
     * Gets cart.
     *
     * @param {object} config Configuration.
     * @param {object} config.localizedInformation Oversatta data.
     * @param {string} config.bagType IRW bag type. Valid values: "onlineshoppingcart", "onlineshoppinglist".
     * @param {string} config.bagName IRW bag name.
     * @param {string} config.userId IRW userid.
     * @param {object} cartInformation Cart information.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_getCart",
    value: function _getCart(config, cartInformation) {
      var _this9 = this;

      return new Promise(function (resolve) {
        var url = _this9._getEndpointUrl(config) + '/' + cartInformation.id;
        fetch(url, {
          headers: _this9._getHeaders(config),
          credentials: 'include'
        }).then(_this9._handleJsonResponse.bind(_this9)).then(function (response) {
          resolve({
            errorList: [],
            cartCount: _this9._calculateCartCountFromResponse(response)
          });
        });
      });
    }
    /**
     * Calculates count of items in cart or list from response.
     *
     * @param {Response} response Response.
     * @returns {number} Cart or list count.
     */

  }, {
    key: "_calculateCartCountFromResponse",
    value: function _calculateCartCountFromResponse(response) {
      var cartCount = null;

      if (response && Array.isArray(response.shoppingBagSectionList)) {
        var items = response.shoppingBagSectionList[0].shoppingBagItemList;

        if (!items) {
          return null;
        }

        cartCount = 0;

        var _iterator5 = _createForOfIteratorHelper(items),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var item = _step5.value;

            if (item.itemQty) {
              cartCount += Number(item.itemQty);
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }

      return cartCount;
    }
    /**
     * Gets request header.
     *
     * @param {object} config Configuration.
     * @param {object} config.localizedInformation Oversatta data.
     * @param {string} config.bagType IRW bag type. Valid values: "onlineshoppingcart", "onlineshoppinglist".
     * @param {string} config.bagName IRW bag name.
     * @param {string} config.userId IRW userid.
     * @returns {object} Request header.
     */

  }, {
    key: "_getHeaders",
    value: function _getHeaders(config) {
      return {
        accept: 'application/vnd.ikea.api+json; version=2',
        'content-type': 'application/json',
        'x-client-id': config.localizedInformation.localization.mvEcomApiKey
      };
    }
    /**
     * Gets endpoint url.
     *
     * @param {object} config Configuration.
     * @param {object} config.localizedInformation Oversatta data.
     * @param {string} config.bagType IRW bag type. Valid values: "onlineshoppingcart", "onlineshoppinglist".
     * @param {string} config.bagName IRW bag name.
     * @param {string} config.userId IRW userid.
     * @returns {string} Endpoint url.
     */

  }, {
    key: "_getEndpointUrl",
    value: function _getEndpointUrl(config) {
      var endpoint = config.localizedInformation.endpoints.mvEcomShoppingBagService;
      var irwBagType = config.bagType === 'onlineshoppinglist' ? 'irw-shopping-list' : 'irw-shopping-cart';

      var _config$localizedInfo = config.localizedInformation.apiLocalePath.split('/'),
          _config$localizedInfo2 = _slicedToArray(_config$localizedInfo, 2),
          country = _config$localizedInfo2[0],
          language = _config$localizedInfo2[1];

      if (_ServiceUrlUtility.default.usingProxy(window.location.hostname)) {
        endpoint = endpoint.replace(/https:\/\/[a-z.]*\/(.*)/i, '/mvecom/$1');
      }

      return endpoint.replace('{irwBagType}', irwBagType).replace('{country}', country).replace('{language}', language).replace('{userId}', config.userId).replace('{cartType}', config.bagType);
    }
    /**
     * Returns the name used by ServiceFactory.
     *
     * @override
     * @returns {string} Factory name.
     */

  }], [{
    key: "factoryName",
    get: function get() {
      return 'mvecom';
    }
  }]);

  return MvEcomService;
}(_AbstractService2.default);

exports.default = MvEcomService;